import React, { useState, useEffect, useRef } from "react";
import api from "../../api"
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { checkPermissionStatus } from "helpers/utils";
import authHeader from "helpers/jwt-token-access/auth-token-header";

import edit_icon from "../../assets/images/icon/edit.svg";
import plus_icon from "../../assets/images/icon/plus.svg";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";

const RoleList = () => {
  const { t } = useTranslation();
  const [rolesData, setRolesData] = useState([]);

  useEffect(() => {
    const fetchRolesData = async () => {
      const token = authHeader();
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/admin/role/role-list`,
        ); // Replace with your actual API URL
        setRolesData(response?.data);
      } catch (error) {
        console.error("Error fetching role data:", error);
      }
    };

    fetchRolesData();
    document.title = "NeuroTal - Role List";
  }, []);

  const handleToggleStatus = async roleId => {
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/role/toggle-status/${roleId}`
      );
      setRolesData(prevRoles =>
        prevRoles.map(role =>
          role.id === roleId
            ? { ...role, status: role.status === 0 ? 1 : 0 } // Toggle status
            : role
        )
      );
    } catch (error) {
      console.error("Error toggling role status:", error);
    }
  };

  
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  if (!checkPermissionStatus("role-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Role List.Access Denied`)}</h4>
      </div>
    );
  }


  return (
    <div className="pending-list-page feedbacks departmentpage">
      <div className="report-wrapper bg-white">
        <div className="joblist-container create-vacancy">
          <Row className="align-items-center  py-2 pt-0">
            <Col lg="6" md="6" className="Joblist-column">
              <Link to="/">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Role List.Role List`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="joblist-container create-vacancy rolist-con position-relative pt-0">
          <div className="report-head d-flex align-items-center justify-content-lg-between pt-0  py-2">
            <div className="record-box usrelist d-flex align-items-center">
              <div className="total-record">
                <h5>
                  {t(`Role List.Total Records`)}:{" "}
                  <span>{rolesData.length}</span>
                </h5>
              </div>
            </div>
            <div className="table-action-btn">
              {/* <Link
                to={`/create-role`}
                className="btn btn-primary d-flex align-items-center gap-2"
              >
                <img src={plus_icon} alt="Download" /> {t(`Role List.Add New`)}
              </Link> */}

              <div className="tale-text right-panel mobile-arrow mb-0">
                <button
                  className="button left"
                  onClick={() => handleScroll("left")}
                  data-tooltip={t(`Role List.Scroll Left`)}
                >
                  <img src={right_arrow} alt="right-arrow" />
                </button>
                <button
                  className="button right"
                  onClick={() => handleScroll("right")}
                  data-tooltip={t(`Role List.Scroll Right`)}
                >
                  <img src={right_arrow} alt="right-arrow" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="report-table-wrapper mt-3">
            <div className="timeto-hire-card userlist  when-data-low  masterstate-cards">
              <div className="table-custome-class range-custome">
                <div className="scroll-container">
                  <div className="table-pending-list">
                    <div className="table-wrapper" ref={tableWrapperRef}>
                      <div className="react-bootstrap-table mb-0">
                        <table
                          className="display dataTable no-footer table table-bordered table-striped"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            <tr>
                              <th>
                                <b>{t(`Role List.Role Name`)}</b>
                              </th>
                              <th className="text-center">
                                <b>{t(`Role List.Status`)}</b>
                              </th>
                              {checkPermissionStatus("role-list", "edit") && (
                                <th className="text-center">
                                  <b>{t(`Role List.Actions`)}</b>
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {rolesData.map(role => (
                              <tr key={role.id}>
                                <td>{role.name}</td>
                                <td className="text-center">
                                  <div className="job-status-toggle">
                                    <label
                                      className="switch"
                                      aria-label="Toggle status for role"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={role.status === 1}
                                        onChange={() =>
                                          handleToggleStatus(role.id)
                                        }
                                       disabled

                                      />
                                      <span className="slider round"></span>
                                    </label>
                                  </div>
                                </td>
                                {checkPermissionStatus("role-list", "edit") && (
                                  <td align="center">
                                    <div className="table-cta-btn d-flex action-one small-img">
                                      <Link
                                        to={`/edit-role/${role.id}`}
                                        className="text-success blue-icon blue-color4"
                                        title={t(`Role List.Edit`)}
                                        data-placement="bottom"
                                        data-toggle="tooltip"
                                      >
                                        {/* <img
                                    src="https://recruit.neurotal.com.au/neuronimbus/assets/images/svg/edit-pencil.svg"
                                    alt="View Details"
                                  /> */}
                                        <img src={edit_icon} alt="edit_icon" />
                                      </Link>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleList;
